<nb-card class="dialog-create-group" *ngIf="folderForm">
    <nb-card-header [class.hidden]="!isCreate">New Folder</nb-card-header>
    <nb-card-header [class.hidden]="isCreate">Edit Folder</nb-card-header>
    <nb-card-body>
    <div class="row">
        <form [formGroup]="folderForm">
            <div class="col-12"><label>Name:</label></div>
            <div class="col-12 folder-field" [ngClass]="{ 'has-error': folderName.invalid && (folderName.dirty || folderName.touched) }">
                <input nbInput placeholder="Folder Name" class="form-control" formControlName="folderName" (input)="folderName.markAsDirty()">
                <span class="hint-text">Maximum 80 characters</span>
                <div class="alert alert-danger" *ngIf="folderName.invalid && (folderName.dirty || folderName.touched)">
                    <span *ngIf="folderName.hasError('maxlength')">
                        Folder name must not exceed 80 characters.
                    </span>
                    <span *ngIf="folderName.hasError('required')">
                        Folder name is required.
                    </span>
                    <span *ngIf="!folderName.hasError('maxlength') && folderName.hasError('pattern')">
                        Invalid folder name format.
                    </span>
                </div>
            </div>
            <div [class.hidden]="isCreate" class="col-12 sub-form"><label>Tag:</label></div>
            <div [class.hidden]="isCreate" class="col-12"><input nbInput placeholder="Tag or Category" class="form-control" formControlName="tag" maxlength="15"></div>
            <div [class.hidden]="isCreate" class="col-12 sub-form"><label>Description:</label></div>
            <div [class.hidden]="isCreate" class="col-12">
                <textarea nbInput class="form-control" rows="2" id="description" name="description" placeholder="Description" formControlName="description" 
                maxlength="250" fullWidth ></textarea>
            </div>
      
        </form>
    </div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton matRipple status="success" (click)="saveFolderName()" [disabled]="folderForm.invalid">Submit</button>
        <button class="cancel" nbButton matRipple status="danger" (click)="cancel()">Cancel</button>
    </nb-card-footer>
</nb-card>